import { Component, Input, OnInit } from '@angular/core';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';
import { BsModalRef } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import { setCustomModalClasses } from '../../helpers/modal_backdrop_custom';
import { ArticoloFull } from '../../interfaces/custom/articolo';
import { Livello } from '../../interfaces/custom/componibili';
import { CartService } from '../../services/cart.service';
import { PriceArticoloService } from '../../services/custom/price-articolo.service';
import { StoreService } from '../../services/store.service';
import { forkJoin, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ShopService } from '../../api/shop.service';
import { Attributo } from '../../interfaces/custom/attributi';
import { CartItem } from '../../interfaces/cart-item';
import { Item } from 'src/app/modules/shop/pages/page-cart/page-cart.component';

@Component({
  selector: 'app-product-customization',
  templateUrl: './product-customization.component.html',
  styleUrls: ['./product-customization.component.scss']
})
export class ProductCustomizationComponent implements OnInit {
  articolo : ArticoloFull;
  qta: number;
  articoli: ArticoloFull[];
  options: any;
  item : Item;
  type: string;

  levels : Livello[];

  onClose;

  loadingComposizioni;
  loadingAttributi;
  readOnlyBoxView = false;

  constructor(public bsModalRef: BsModalRef, private store : StoreService, private cart : CartService,
    public priceArticolo : PriceArticoloService, private shop : ShopService) {

  }

  isB2B() {
    return this.store.price == 'b2b';
  }

  ngOnInit(): void {
    setCustomModalClasses();
    this.readOnlyBoxView = !this.cart.isCheckoutAvailable();

    if (this.item) {
      this.articolo = JSON.parse(JSON.stringify(this.item.cartItem.product));
      this.qta = this.item.quantity;
    }

    let articoli$ = of(this.articoli);
    if (!this.articoli) {
      articoli$ = this.shop.getArticoliComposizione(this.articolo.codart);
    }

    if (this.articolo.composizione_articolo) {
      this.loadingComposizioni = true;
      articoli$.pipe(finalize(() => this.loadingComposizioni = false)).subscribe(r => {
        this.articoli = r;

        for (let articolo of this.articolo.composizione_articolo) {
          articolo.codice_articolo_componente = articolo.codice_articolo_componente.trim();
          articolo.articolo_componente = this.articoli.find(obj => obj.codart == articolo.codice_articolo_componente);
        }
        this.levels = this.articolo.livelli_composizione;
        for (let level of this.levels) {
          level.items = this.articolo.composizione_articolo.filter(obj => obj.codice_livello == level.codice_livello);
        }
    
        for (let level of this.levels) {
          for (let item of level.items) {
            if (item.must_have) {
              item.qta_selezionata = item.qta;
            }

            if (this.item && this.item.cartItem.box_levels) {
              let level = this.item.cartItem.box_levels.find(level => level.codice_livello == item.codice_livello);
              if (level) {
                let items = level.items;
                let foundItem = items.find(it => it.codice_articolo_componente == item.codice_articolo_componente);
                if (foundItem)
                  item.qta_selezionata = foundItem.qta_selezionata || item.qta_selezionata;
              }
            }
          }
        }
      },
      err => {
        if (this.item.cartItem.box_levels)
          this.levels = JSON.parse(JSON.stringify(this.item.cartItem.box_levels));
      });
      
    }

    if (this.item) {
      if (this.item.cartItem.attributi && this.articolo.attributi) {
        for (let attributo of this.item.cartItem.attributi) {
          let attr = this.articolo.attributi.find(attr => attr.progressivo == attributo.progressivo);
          attr.selected = attributo.selected;
        }
      }
    }
    
    let waitingAttr$ = of({});
    if (this.articolo.attributi && this.articolo.attributi.length) {
      let attributiCollegati = this.articolo.attributi.filter(attr => attr.tipo_battuta == 0);
      let bunch = {};
      attributiCollegati.forEach(attr => {
        bunch[attr.articolo_collegato] = this.shop.getArticolo(attr.articolo_collegato).pipe(
          catchError(err => of(null))
        );
      });

      if (Object.keys(bunch).length)
        waitingAttr$ = forkJoin(bunch);

      this.loadingAttributi = true;
      waitingAttr$.pipe(finalize(() => this.loadingAttributi = false)).subscribe(r => {
        attributiCollegati.forEach(attr => {
          attr.articolo = r[attr.articolo_collegato];
        });
      });
    }

  }

  showPrices() {
    return this.articolo && this.articolo.calcolo_prezzo == 1 && !this.articolo.flg_esplosione;
  }

  isInteractiveBoxView() {
    return !this.readOnlyBoxView;
  }

  isAvailable(item) {
    if (!item.articolo_componente)
      return false;

    for (let i = 1; i <= 4; i++) {
      if (item.articolo_componente['option_list' + i])
        return false;
    }

    if (this.articolo.flg_esplosione)
      return true;

    if (item.articolo_componente.acquisti_giacenza_negativa)
      return true;

    let available_quantity = item.articolo_componente.disponibilita_prodotto;
    let inCart = this.cart.getQuantityOfItemInCart(item.articolo_componente);
    let inBox = this.getQtyOfItemInBox(item.codice_articolo_componente);
    let inBoxCart = 0;
    if (this.item)
      inBoxCart = this.getQtyOfItemInBox(item.codice_articolo_componente, this.item.cartItem);

    let selectedQty = 0;
    if (!item.qta_selezionata) {
      if (this.item)
        selectedQty = this.item.quantity;
      else
        selectedQty = this.qta;
    }

    let remain_qta = available_quantity - inCart + inBoxCart - inBox - selectedQty;
    return remain_qta >= 0;
  }

  isAttributeAvailable(attr : Attributo) {
    if (attr.tipo_battuta != 0)
      return true;
    
    if (!attr.articolo)
      return false;

    for (let i = 1; i <= 4; i++) {
      if (attr.articolo['option_list' + i])
        return false;
    }
    
    if (attr.articolo.acquisti_giacenza_negativa)
      return true;

    let available_quantity = attr.articolo.disponibilita_prodotto;
    let inCart = this.cart.getQuantityOfItemInCart(attr.articolo);
    let inBox = this.getQtyOfItemInBox(attr.articolo_collegato);
    let inBoxCart = 0;
    if (this.item)
      inBoxCart = this.getQtyOfItemInBox(attr.articolo_collegato, this.item.cartItem);

    let selectedQty = 0;
    if (!attr.selected) {
      if (this.item)
        selectedQty = this.item.quantity;
      else
        selectedQty = this.qta;
    }

    let remain_qta = available_quantity - inCart + inBoxCart - inBox - selectedQty;
    return remain_qta >= 0;
  }

  toggleAttribute(attr) {
    if (this.readOnlyBoxView)
      return;

    if (attr.selected)
      attr.selected = false;
    else {
      if (this.isAttributeAvailable(attr))
        attr.selected = true;
    }
  }

  getQtyOfItemInBox(codart, item? : CartItem) {
    let count = 0;

    let levels = this.levels;
    let attributes = this.articolo.attributi;

    if (item) {
      levels = item.box_levels;
      attributes = item.attributi;      
    }

    if (levels) {
      levels.forEach(level => {
        level.items.forEach(it => {
          if (it.codice_articolo_componente == codart)
            count += it.qta_selezionata || 0;
        })
      });
  
      if (this.item)
        count *= this.item.quantity;
      else
        count *= this.qta;
    }

    if (attributes) {
      let attrCount = 0;
      attributes.forEach(attribute => {
        if (attribute.tipo_battuta == 0 && attribute.selected && attribute.articolo_collegato == codart && attribute.articolo)
          attrCount += 1;
      });
      if (this.item)
        attrCount *= this.item.quantity;
      else
        attrCount *= this.qta;

      count += attrCount;
    }

    return count;
  }

  canAddToCart() {
    if (this.loadingAttributi || this.loadingComposizioni)
      return false;
      
    if (this.levels) {
      for (let level of this.levels) {
        for (let item of level.items)
          if (item.qta_selezionata && !this.isAvailable(item))
            return false;
      }
    }

    if (this.articolo.attributi) {
      let selectedAttributes = this.articolo.attributi.filter(attr => attr.selected && attr.tipo_battuta == 0);
      return !selectedAttributes.some(attr => !this.isAttributeAvailable(attr));
    }

    return true;
  }

  toggleItem(item, changedBy?, ev?) {
    if (this.readOnlyBoxView)
      return;

    if (changedBy)
      ev.stopPropagation();

    if (!item.qta_selezionata) {
      if (!this.canAddToLevel(item.codice_livello))
        return;
      if (!this.isAvailable(item))
        return;
      item.qta_selezionata = item.qta;
    }
    else if (!changedBy) {
      if (item.must_have)
        return;
      item.qta_selezionata = undefined;
    }
    else {
      if (changedBy == 1 && !this.canAdd(item))
        return;
      if (changedBy == -1 && !this.canRemove(item))
        return;
      item.qta_selezionata += changedBy;
      if (item.qta_selezionata < item.qta || item.qta_selezionata == 0)
        item.qta_selezionata = undefined;
    }
  }

  canAddToLevel(lvl_code) {
    let lvl = this.levels.find(obj => obj.codice_livello == lvl_code);
    let total_selected = lvl.items.filter(item => item.qta_selezionata);
    return total_selected.length < lvl.limite_articoli;
  }

  canAdd(item) {
    if (!item.qta_selezionata && this.canAddToLevel(item.codice_livello))
      return true;
    if (item.qta_selezionata < item.limite_qta)
      return true;
  }

  canRemove(item) {
    if (item.must_have)
      return item.qta_selezionata > item.qta;
    else return true;
  }

  get total() {
    if (this.loadingComposizioni || this.loadingAttributi)
      return 0;
    if ((this.articolo.tipo_articolo == 5 || this.articolo.tipo_articolo == 6) && this.articolo.calcolo_prezzo == 1 && !this.articolo.flg_esplosione) {
      let total = 0;
      for (let level of this.levels) {
        for (let item of level.items) {
          if (item.qta_selezionata) {
            let prezzo = this.store.price == 'b2b' ? item.prezzo_netto : item.prezzo_lordo;
            total += item.qta_selezionata * prezzo;
          }
        }
      }
      return total;
    }
    else {
      return this.articolo.prezzo;
    }
    
  }

  addToCart() {
    if (this.readOnlyBoxView)
      return;

    if (this.hasErrors()) {
      Swal.fire('', 'Quantità degli articoli errata in alcuni sezioni', 'warning');
      return;
    }

    //Se l'articolo è un Box Semplice o un Box Componibile
    if (this.articolo.tipo_articolo == 5 || this.articolo.tipo_articolo == 6) {
      let filtered_levels = [...this.levels];
      for (let level of filtered_levels) {
        level.items = level.items.filter(item => item.qta_selezionata);
      }

      if (!this.item)
        this.cart.addBox(this.articolo, this.qta, filtered_levels).subscribe();
      else {
        this.item.cartItem.box_levels = this.levels;
        this.item.cartItem.attributi = this.articolo.attributi ? this.articolo.attributi.filter(a => a.selected) : null;
      }
      if (this.onClose)
        this.onClose();
      this.bsModalRef.hide();
    }
    else {
      if (!this.item)
        this.cart.add(this.articolo, this.qta, this.options).subscribe();
      else {
        this.item.cartItem.attributi = this.articolo.attributi ? this.articolo.attributi.filter(a => a.selected) : null;
      }
      
      if (this.onClose)
        this.onClose();
      this.bsModalRef.hide();
    }
    
  }

  errorsChecked;
  hasErrors() {
    if (!this.levels)
      return;
    this.errorsChecked = true;
    for (let level of this.levels) {
      if (this.isLevelHaveQuantityError(level))
        return true;
    }
    return false;
  }

  isLevelHaveQuantityError(level) {
    let min = level.minimo_articoli;
    let max = level.limite_articoli;

    let total_selected = 0;
    for (let item of level.items) {
      if (item.qta_selezionata)
        total_selected += 1;
    }
    if (total_selected < min)
      return `Minimo ${min} articol${min == 1 ? 'o': 'i'}`;
  
    if (total_selected > max)
      return `Massimo ${max} articol${max == 1 ? 'o': 'i'}`;
  }

}
